// Países + códigos de discagem pro seletor de telefone do Minha Conta.
//
// Estratégia de UI (decisão Luís 2026-05-27): os FAVORITOS aparecem sempre;
// um "Ver mais" abre a lista completa com busca. O telefone é guardado em
// E.164 ("+" + código do país + número nacional), formato que o WhatsApp/
// Twilio exige (ver whatsapp-config.normalizePhone no backend).

export interface Country {
  /** ISO 3166-1 alpha-2 (chave estável). */
  iso2: string;
  /** Nome em PT-BR. */
  name: string;
  /** Código de discagem SEM o "+". Ex: "55", "351", "1". */
  dial: string;
  /** Emoji da bandeira. */
  flag: string;
}

// ISO2 dos favoritos que ficam sempre visíveis (na ordem desejada). Brasil
// primeiro por ser a esmagadora maioria da base.
export const FAVORITE_ISO2 = [
  "BR",
  "PT",
  "US",
  "AR",
  "UY",
  "PY",
  "CL",
  "ES",
  "GB",
  "AO",
  "MZ",
  "JP"
];

// Lista completa (curada — cobre os principais; dá pra crescer). Ordenada
// alfabeticamente por nome na hora de exibir.
export const COUNTRIES: Country[] = [
  { iso2: "BR", name: "Brasil", dial: "55", flag: "🇧🇷" },
  { iso2: "PT", name: "Portugal", dial: "351", flag: "🇵🇹" },
  { iso2: "US", name: "Estados Unidos", dial: "1", flag: "🇺🇸" },
  { iso2: "AR", name: "Argentina", dial: "54", flag: "🇦🇷" },
  { iso2: "UY", name: "Uruguai", dial: "598", flag: "🇺🇾" },
  { iso2: "PY", name: "Paraguai", dial: "595", flag: "🇵🇾" },
  { iso2: "CL", name: "Chile", dial: "56", flag: "🇨🇱" },
  { iso2: "ES", name: "Espanha", dial: "34", flag: "🇪🇸" },
  { iso2: "GB", name: "Reino Unido", dial: "44", flag: "🇬🇧" },
  { iso2: "AO", name: "Angola", dial: "244", flag: "🇦🇴" },
  { iso2: "MZ", name: "Moçambique", dial: "258", flag: "🇲🇿" },
  { iso2: "JP", name: "Japão", dial: "81", flag: "🇯🇵" },
  { iso2: "BO", name: "Bolívia", dial: "591", flag: "🇧🇴" },
  { iso2: "PE", name: "Peru", dial: "51", flag: "🇵🇪" },
  { iso2: "CO", name: "Colômbia", dial: "57", flag: "🇨🇴" },
  { iso2: "VE", name: "Venezuela", dial: "58", flag: "🇻🇪" },
  { iso2: "EC", name: "Equador", dial: "593", flag: "🇪🇨" },
  { iso2: "MX", name: "México", dial: "52", flag: "🇲🇽" },
  { iso2: "CA", name: "Canadá", dial: "1", flag: "🇨🇦" },
  { iso2: "FR", name: "França", dial: "33", flag: "🇫🇷" },
  { iso2: "DE", name: "Alemanha", dial: "49", flag: "🇩🇪" },
  { iso2: "IT", name: "Itália", dial: "39", flag: "🇮🇹" },
  { iso2: "NL", name: "Países Baixos", dial: "31", flag: "🇳🇱" },
  { iso2: "BE", name: "Bélgica", dial: "32", flag: "🇧🇪" },
  { iso2: "CH", name: "Suíça", dial: "41", flag: "🇨🇭" },
  { iso2: "AT", name: "Áustria", dial: "43", flag: "🇦🇹" },
  { iso2: "IE", name: "Irlanda", dial: "353", flag: "🇮🇪" },
  { iso2: "SE", name: "Suécia", dial: "46", flag: "🇸🇪" },
  { iso2: "NO", name: "Noruega", dial: "47", flag: "🇳🇴" },
  { iso2: "DK", name: "Dinamarca", dial: "45", flag: "🇩🇰" },
  { iso2: "FI", name: "Finlândia", dial: "358", flag: "🇫🇮" },
  { iso2: "PL", name: "Polônia", dial: "48", flag: "🇵🇱" },
  { iso2: "CZ", name: "Tchéquia", dial: "420", flag: "🇨🇿" },
  { iso2: "GR", name: "Grécia", dial: "30", flag: "🇬🇷" },
  { iso2: "RU", name: "Rússia", dial: "7", flag: "🇷🇺" },
  { iso2: "UA", name: "Ucrânia", dial: "380", flag: "🇺🇦" },
  { iso2: "TR", name: "Turquia", dial: "90", flag: "🇹🇷" },
  { iso2: "IL", name: "Israel", dial: "972", flag: "🇮🇱" },
  { iso2: "AE", name: "Emirados Árabes Unidos", dial: "971", flag: "🇦🇪" },
  { iso2: "SA", name: "Arábia Saudita", dial: "966", flag: "🇸🇦" },
  { iso2: "ZA", name: "África do Sul", dial: "27", flag: "🇿🇦" },
  { iso2: "NG", name: "Nigéria", dial: "234", flag: "🇳🇬" },
  { iso2: "EG", name: "Egito", dial: "20", flag: "🇪🇬" },
  { iso2: "MA", name: "Marrocos", dial: "212", flag: "🇲🇦" },
  { iso2: "CV", name: "Cabo Verde", dial: "238", flag: "🇨🇻" },
  { iso2: "IN", name: "Índia", dial: "91", flag: "🇮🇳" },
  { iso2: "CN", name: "China", dial: "86", flag: "🇨🇳" },
  { iso2: "KR", name: "Coreia do Sul", dial: "82", flag: "🇰🇷" },
  { iso2: "ID", name: "Indonésia", dial: "62", flag: "🇮🇩" },
  { iso2: "TH", name: "Tailândia", dial: "66", flag: "🇹🇭" },
  { iso2: "PH", name: "Filipinas", dial: "63", flag: "🇵🇭" },
  { iso2: "SG", name: "Singapura", dial: "65", flag: "🇸🇬" },
  { iso2: "MY", name: "Malásia", dial: "60", flag: "🇲🇾" },
  { iso2: "AU", name: "Austrália", dial: "61", flag: "🇦🇺" },
  { iso2: "NZ", name: "Nova Zelândia", dial: "64", flag: "🇳🇿" },
  { iso2: "PK", name: "Paquistão", dial: "92", flag: "🇵🇰" },
  { iso2: "BD", name: "Bangladesh", dial: "880", flag: "🇧🇩" }
];

const BY_ISO2 = new Map(COUNTRIES.map((c) => [c.iso2, c]));

export const DEFAULT_COUNTRY = BY_ISO2.get("BR")!;

export function countryByIso2(iso2: string): Country | undefined {
  return BY_ISO2.get(iso2);
}

export function favoriteCountries(): Country[] {
  return FAVORITE_ISO2.map((iso) => BY_ISO2.get(iso)).filter(
    (c): c is Country => !!c
  );
}

/** Lista completa ordenada por nome (PT). */
export function allCountriesSorted(): Country[] {
  return [...COUNTRIES].sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
}

/** Monta E.164: "+" + dial + dígitos nacionais. Vazio se sem número. */
export function toE164(dial: string, national: string): string {
  const nat = national.replace(/\D/g, "");
  if (!nat) return "";
  return `+${dial}${nat}`;
}

/** Tenta separar um valor salvo em país + número nacional.
 *  - Com "+": casa o código de discagem mais longo conhecido.
 *  - Sem "+": assume Brasil (legado nacional "11999999999").
 *  Retorna country=DEFAULT quando não dá pra inferir. */
export function parseStoredPhone(raw: string | null | undefined): {
  country: Country;
  national: string;
} {
  const value = (raw ?? "").trim();
  if (!value) return { country: DEFAULT_COUNTRY, national: "" };

  if (value.startsWith("+")) {
    const digits = value.slice(1).replace(/\D/g, "");
    // Match pelo dial mais longo (3 → 2 → 1 dígitos).
    for (let len = 4; len >= 1; len--) {
      const prefix = digits.slice(0, len);
      const match = COUNTRIES.find((c) => c.dial === prefix);
      if (match) {
        return { country: match, national: digits.slice(len) };
      }
    }
    // Sem match — devolve tudo como nacional sob o país default.
    return { country: DEFAULT_COUNTRY, national: digits };
  }

  // Sem "+": legado nacional. Mantém Brasil como país e os dígitos como número.
  return { country: DEFAULT_COUNTRY, national: value.replace(/\D/g, "") };
}
